module.exports = __webpack_public_path__ + "zl7-c3996cd8.png";